module.exports = __webpack_public_path__ + "img/serve3.67e338ac.png";